import { aboutStats, site } from "@/data/portfolioData";
import { useReveal } from "@/hooks/useReveal";

export function About() {
  const revealRef = useReveal();

  return (
    <section
      id="about"
      ref={revealRef}
      className="stack-mobile relative z-[2] grid items-center gap-12 px-6 pb-[70px] pt-8 md:grid-cols-2 md:px-14"
    >
      <div className="rounded-3xl border-3 border-ink bg-periwinkle p-11 shadow-neo-lg">
        <p className="mb-[18px] font-display text-[15px] text-ink">SINCE 2018</p>
        <div className="flex flex-col gap-[18px]">
          {aboutStats.map((stat) => (
            <div key={stat.label} className="flex items-baseline gap-3.5">
              <span className="font-display text-[40px] text-ink">{stat.value}</span>
              <span className="text-base font-semibold text-ink">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className="mb-1.5 text-base font-bold text-teal">A little about me</p>
        <h2 className="mb-[18px] font-display text-[38px] text-ink">Infrastructure is my craft.</h2>
        <p className="mb-4 text-[17px] leading-[1.7] text-muted">
          Over the past {site.years} years I&apos;ve helped fintechs, banks, and scale-ups move from
          fragile manual deploys to fully automated, observable, self-healing platforms across AWS,
          Azure, GCP, and on-prem.
        </p>
        <p className="m-0 text-[17px] leading-[1.7] text-muted">
          I bridge DevOps excellence and AI engineering, from MLOps pipelines to multi-cloud
          Kubernetes orchestration. I care about reliability, cost efficiency, and making on-call
          boring. When systems fail, I want to already know why.
        </p>
        <p className="mt-4 text-base text-muted2">
          📍 {site.location} · ✉️ {site.email}
        </p>
      </div>
    </section>
  );
}
